export function ajistudio(bp, $) {
    const equipment = {
        slider() {
            const $slider = $('.section__slider-mv').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                arrows: true,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><span class="btn--arrow _sm _white"><i class="fa fa-left-arrow"></i></span></button>',
                nextArrow:'<button class="slick-next" aria-label="Next" type="button"><span class="btn--arrow _sm _white"><i class="fa fa-right-arrow"></i></span></button>',
            });

            const $thumb = $('#js-thumb .thumb__item');
            $thumb.on('click', function(){
                const i = $(this).index();
                $slider.slick('slickGoTo', i);
            });
        }
    };


    equipment.slider();

    $(window).resize(function() {
       // Resize Statement
    });
}
